const langtrans={
      czkkbb:["查看并处理","Check and process"],
      czkk:["查看","Check"],
      sjj:["时间","Time"],
      cczzzf:["操作方","Operating Party"],
      cczzfff:["服务方","Service Party"],
      cczzzj:["操作节点","Operation Node"],
      cczzzx:["操作细节","Details"],
      zt:["状态","Status"],
      ajyhs:["案件已耗时：","Time taken:"],
      sqgzzz:["收起工作台","Retract worktable"],
      ajgzzz:["案件工作台","Case worktable"],
      dddfab:["等待方案报价中","Waiting for quotation"],
      dddsqz:["等待授权中","Waiting for authorization"],
      jyzzaj:["救援中案件管理","Management of cases in progress"],
      ajywc:["案件已完成","Case completed"],
      dddsqq:["等待授权启动","en_translated"],
      ywcjya:["已完成救援案件","Cases completed"],
      wqdjy:["未启动救援","en_translated"],
      dddqds:["等待启动授权","en_translated"],
      qdsqtt:["启动授权通过，待转交救援机构报价","en_translated"],
      dddjyg:["等待救援公司报价中","en_translated"],
      yzzzjb:["已转交报价，等待监管授权","en_translated"],
      bjjjsq:["报价授权通过，请开始救援","en_translated"],
      ksjyzz:["开始救援中","en_translated"],
      jywcdd:["救援完成待确认","en_translated"],
      jywc:["救援完成","en_translated"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/views/cmd_center/js/case.vue.trans.js